import React from "react"
import { translations } from "../../../utils/Translation/staticTranslation"

const MerAnalyticsCards = ({ data }) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.MerchantAnalytics || {}
  // console.log(data, "data two");
  const cards = [
    {
      title: t.cards?.active_merchants || "Active Merchants",
      value: data?.result?.active_merchants,
      icon: "/MerchantAnalytics/user-icon.svg",
      image: "/MerchantAnalytics/blue-analytics-ch.svg",
      color: "rgba(240, 252, 255, 1)",
      iconDivBoarder: "rgba(0, 192, 232, 0.25)",
    },
    {
      title: t.cards?.pending_merchants || "Pending Merchants",
      value: data?.result?.pending_merchants,
      icon: "/MerchantAnalytics/user-lock-orang.svg",
      image: "/MerchantAnalytics/orange-analytics-ch.svg",
      color: "rgba(255, 246, 238, 1)",
      iconDivBoarder: "rgba(255, 141, 40, 0.25)",
    },
    {
      title: t.cards?.waiting_merchants || "Waiting Merchants",
      value: data?.result?.waiting_merchants,
      icon: "/MerchantAnalytics/user-question-bblue.svg",
      image: "/MerchantAnalytics/blue-dark-ch.svg",
      color: "rgba(240, 246, 255, 1)",
      iconDivBoarder: "rgba(0, 136, 255, 0.25)",
    },
    {
      title: t.cards?.total_stores || "Total Stores",
      value: data?.result?.total_stores,
      icon: "/MerchantAnalytics/total-store.svg",
      image: "/MerchantAnalytics/purple-ch.svg",
      color: "rgba(253, 241, 255, 1)",
      iconDivBoarder: "rgba(203, 48, 224, 0.25)",
    },
  ]

  const TotalViewCards = [
    {
      title: t.cards?.active_stores || "Active Stores",
      value: data?.result?.active_stores,
      icon: "/MerchantAnalytics/active-store.svg",
      image: "/MerchantAnalytics/green-ch.svg",
      color: "rgba(236, 255, 253, 1)",
      iconDivBoarder: "rgba(0, 200, 179, 0.25)",
    },
    {
      title: t.cards?.total_products || "Total Products",
      value: data?.result?.total_products,
      icon: "/MerchantAnalytics/total-products.svg",
      image: "/MerchantAnalytics/onion-ch.svg",
      color: "rgba(246, 240, 255, 1)",
      iconDivBoarder: "rgba(97, 85, 245, 0.25)",
    },
    {
      title: t.cards?.active_products || "Active Products",
      value: data?.result?.active_products,
      icon: "/MerchantAnalytics/active-products.svg",
      image: "/MerchantAnalytics/pink-ch.svg",
      color: "rgba(255, 240, 246, 1)",
      iconDivBoarder: "rgba(248, 69, 138, 0.25)",
    },
    {
      title: t.cards?.total_views || "Total Views",
      value: data?.result?.total_impressions,
      icon: "/MerchantAnalytics/total-view.svg",
      image: "/MerchantAnalytics/blue-analytics-ch.svg",
      color: "rgba(234, 248, 255, 1)",
      iconDivBoarder: "rgba(16, 153, 227, 0.25)",
    },
    {
      title: t.cards?.clicks || "Clicks",
      value: data?.result?.total_clicks,
      icon: "/MerchantAnalytics/Impressions.svg",
      image: "/MerchantAnalytics/orange-analytics-ch.svg",
      color: "rgba(255, 241, 245, 1)",
      iconDivBoarder: "rgba(191, 9, 61, 0.25)",
    },
    {
      title: t.cards?.ctr || "CTR",
      value: data?.result?.ctr,
      icon: "/MerchantAnalytics/CTR.svg",
      image: "/MerchantAnalytics/blue-dark-ch.svg",
      color: "rgba(236, 255, 243, 1)",
      iconDivBoarder: "rgba(0, 200, 83, 0.25)",
    },
  ]

  return (
    <>
      <div className="mer-cards">
        {cards.map((card, index) => (
          <div className="mer-card" key={index}>
            <div className="card-left">
              <div
                className="card-icon"
                style={{
                  width: "24px",
                  height: "24px",
                  background: card.color,
                  border: `1px solid ${card.iconDivBoarder}`,
                  borderRadius: "6px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={card.icon} alt={card.title} width={13} height={13} />
              </div>
              <div className="card-title">{card.title}</div>
              <div className="card-value">{card.value}</div>
            </div>
            <div className="card-right">
              <img
                src={card.image}
                alt={`${card.title} chart`}
                width={100}
                height={60}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mer-cards-total">
        {TotalViewCards.map((card, index) => (
          <div className="mer-card" key={index}>
            <div className="card-left">
              <div
                className="card-icon"
                style={{
                  width: "24px",
                  height: "24px",
                  background: card.color,
                  border: `1px solid ${card.iconDivBoarder}`,
                  borderRadius: "6px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={card.icon} alt={card.title} width={13} height={13} />
              </div>
              <div className="card-title">{card.title}</div>
              <div className="card-value">{card.value}</div>
            </div>
            <div className="card-right">
              <img
                src={card.image}
                alt={`${card.title} chart`}
                width={100}
                height={60}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default MerAnalyticsCards
